import * as _ from 'underscore';
import { Messages } from '../../codegen/Localize';
import { AlertErrorCode } from '../../ts/helpers/ErrorCodes';
import { IDataSourceInfo } from '../../ts/models/IDataSourceInfo';
import { Set } from '../../ts/models/Set';
import { DataSources } from '../../content/resources/Datasources';
import { ICheckConnectionResult } from '../../ts/ServerApi/requests/CheckConnectionRequest';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { ContentActionNotification } from '../../commonInfra/contentActions/ContentActionNotification';
import { openReactConfirmationDialog } from '../../commonInfra/dialogs/ReactConfirmationDialog';
import { toNativePromise } from '../../commonInfra/utils/QUtils';
import { TabDialogWidth } from '../../commonInfra/dialogs/style/TabDialogWidth';
import {
  simpleActionErrorMsg,
  simpleActionSuccessMsg
} from '../../commonInfra/contentActions/ActionHelpers';

function execute(dataSources: Set<IDataSourceInfo>): Promise<IResult>{
  const datasource = dataSources.first();
  const dataSourceIdArray = dataSources.map(ds => ds.id);
  let workbookId = datasource.workbook != null ? datasource.workbook.id : '';
  const dataSourcesToCheck = dataSources.filter((datasource) => datasource.dataConnectionsCount === 1);

  const dialogConfig = openReactConfirmationDialog<void,IResult>(
    {
      title: Messages.changeExtractDsToLive(),
      actionName: Messages.changeExtractDsToLiveConfirm(),
      message: Messages.changeExtractDsToLiveBody(),
      action: async () => {
        if (dataSourcesToCheck.size() > 0) {
          const results: ICheckConnectionResult[] = await DataSources.checkConnections(dataSourcesToCheck);
          if (!_.all(results, result=>result.succeeded)) {
            const failedCheckConection: IResult = {errors:[]};
            dataSourcesToCheck.each(() => {
              failedCheckConection.errors.push({code:AlertErrorCode.AlertConnectionlessFailure, message:'connection test failed'});
            });
            if(failedCheckConection && failedCheckConection.errors && failedCheckConection.errors.length)
              {
                  ContentActionNotification.displayToastForGenericError(failedCheckConection.errors[0]);
              }
            return Promise.reject(failedCheckConection);
          }
        }
        const changeToLivePromise = DataSources.changeToLive(dataSourceIdArray, workbookId);
        changeToLivePromise
        .then((result: IResult) => {
          ContentActionNotification.displaySingleToastForResult({
            items: dataSources,
            errors: result.errors,
            successMsg: simpleActionSuccessMsg(Messages.changeExtractDsToLiveSuccess),
            errorMsg: simpleActionErrorMsg(Messages.changeExtractDsToLiveError),
          });
          return result;
      });
      return changeToLivePromise;
      },

      paramsForAction: undefined,
      dialogWidth: TabDialogWidth.width375px

    });

  return toNativePromise(dialogConfig.result);
}

export const ChangeExtractDsToLiveAction = {
    execute
};

export type ChangeExtractDsToLiveAction = typeof ChangeExtractDsToLiveAction;
